<template>
  <v-snackbar
    v-model="alertIsShowing"
    :color="alert.type === 'info' ? 'deep-purple accent-4' : alert.type"
    :transition="alert.type === 'info' ? 'slide-x-reverse-transition' : 'slide-y-reverse-transition'"
    elevation="24"
    :timeout="alert.options ? alert.options.timeout : 5000"
    :right="alert.type === 'info'"
    :top="alert.type === 'info'"
    :class="alert.type === 'info' ? 'mt-16' : ''"
    :max-width="alert.type === 'info' ? '400' : ''"
  >
    <template #action="{ attrs }">
      <v-btn
        v-if="hasClickHandler"
        icon
        v-bind="attrs"
        @click="onClick"
      >
        <v-icon>
          mdi-message-arrow-right-outline
        </v-icon>
      </v-btn>

      <v-btn
        icon
        v-bind="attrs"
        @click="hideAlert"
      >
        <v-icon>
          close
        </v-icon>
      </v-btn>
    </template>
    <!-- eslint-disable vue/no-v-html -->
    <span
      v-if="alert"
      @click="onClick"
      v-html="alert.message"
    />
    <!-- eslint-enable -->
  </v-snackbar>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'AlertBox',

  computed: {
    alertIsShowing: {
      get () {
        return this.alert?.isShowing || false
      },

      set (value) { this.setAlert({ ...this.alert, isShowing: value }) },
    },

    hasClickHandler () {
      return !!this.alert?.options?.onClick
    },

    ...mapGetters([
      'alert',
    ]),
  },

  methods: {
    hideAlert () {
      this.setAlert(null)
    },

    onClick () {
      if (!this.hasClickHandler) return

      this.alert.options.onClick()
      this.setAlert(null)
    },

    ...mapMutations([
      'setAlert',
    ]),
  },
}
</script>
